import { render, staticRenderFns } from "./NewContent.vue?vue&type=template&id=036432b4&scoped=true"
import script from "./NewContent.vue?vue&type=script&lang=js"
export * from "./NewContent.vue?vue&type=script&lang=js"
import style0 from "./NewContent.vue?vue&type=style&index=0&id=036432b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036432b4",
  null
  
)

export default component.exports